module.exports = __webpack_public_path__ + "img/badge-alipay.57327e35.svg";